import styled from '@emotion/styled';
import { Select } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../../../entities/detenteur.entity';
import { TitreEntity } from '../../../../../entities/titre.entity';
import { ParameterType } from '../../../../../redux/userStore/reducer';
import { formatNum } from '../../../../../shared/constants';
import { getDetenteurs } from '../../../../panel/emissionTitre/network';
import { getParameter } from '../../../network';

const Container = styled.div`
  font-family: Poppins-R;
  color: var(--mt-text);

  p {
    margin: 0px;
  }

  .order-hero {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 16px;
    border: 1px solid var(--mt-border);
    border-radius: 10px;
    background-color: var(--mt-surface);
  }

  .order-title span,
  .section-title {
    color: var(--mt-muted);
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .order-title strong {
    display: block;
    margin-top: 3px;
    color: var(--mt-text);
    font-family: Poppins-B;
    font-size: 20px;
  }

  .side-badge {
    align-self: flex-start;
    min-width: 120px;
    padding: 8px 14px;
    border-radius: 999px;
    color: #07141c;
    background-color: var(--mt-warning);
    font-family: Poppins-B;
    text-align: center;
    text-transform: uppercase;
  }

  .modal-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-top: 12px;
  }

  .section-card {
    min-width: 0;
    padding: 12px;
    border: 1px solid var(--mt-border);
    border-radius: 10px;
    background-color: var(--mt-card);
  }

  .section-title {
    display: block;
    margin-bottom: 9px;
    color: var(--mt-warning);
    font-family: Poppins-B;
  }

  .kv-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 6px 0;
    border-top: 1px solid rgba(148, 163, 184, 0.18);
    color: var(--mt-muted);
    font-size: 13px;
  }

  .kv-row:first-of-type {
    border-top: 0;
  }

  .kv-row strong {
    color: var(--mt-text);
    font-family: Poppins-B;
    text-align: right;
    white-space: nowrap;
  }

  .client-card {
    margin-top: 12px;
  }

  .client-line {
    display: grid;
    grid-template-columns: 120px minmax(0, 1fr);
    gap: 12px;
    align-items: center;
  }

  .total-strip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    margin-top: 12px;
    padding: 14px 16px;
    border: 1px solid rgba(255, 176, 0, 0.34);
    border-radius: 10px;
    background-color: var(--mt-surface);
  }

  .total-strip span {
    color: var(--mt-muted);
    font-size: 12px;
  }

  .total-strip strong {
    color: #008f4f;
    font-family: Poppins-B;
    font-size: 22px;
    white-space: nowrap;
  }

  @media (max-width: 760px) {
    .modal-grid {
      grid-template-columns: 1fr;
    }

    .order-hero,
    .total-strip {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;

export const ConfirmationOrder = ({
  titre,
  typeOpe,
  detailOpe,
  getSelectedDetenteur,
}: {
  titre: TitreEntity;
  typeOpe: 'vente' | 'achat';
  detailOpe: any;
  getSelectedDetenteur: (detUrl: string) => void;
}) => {
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [detenteurs, setDetenteurs] = useState<any[]>([]);
  const [parameter, setParameter] = useState<ParameterType>({
    id: '',
    com_intermediation: 0,
    com_conservation: 0,
    droit_garde: 0,
    com_courtage: 0,
    created_at: '',
  });

  useEffect(() => {
    getDetenteurs(connectedUser.id).then(({ data }) => {
      setDetenteurs(
        data.map((det: DetenteurEntity) => {
          return {
            label: `${det.code_referent} - ${det.nom} ${det.prenom || ''}`,
            value: det.url,
          };
        }),
      );
    });

    getParameter(1).then(({ data: response }) => {
      setParameter(response);
      console.log(response);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const datejour = new Date();

  const dateMature = new Date(titre.dateMaturite);
  var duree_annee =
    (dateMature.getTime() - datejour.getTime()) / (1000 * 60 * 24 * 365);
  //recupérons les chiffres après la virgule
  var valString = duree_annee.toString();
  var nbre = valString.split('.');
  var delta = parseFloat('0.' + nbre[1]);
  const prixTaux = (detailOpe.qte * 10000 * titre.tauxMarginal) / 100;
  const valaRestant = prixTaux * delta;
  var valaPercevoir: any = valaRestant.toFixed(2);
  var valaPayer = prixTaux - valaPercevoir;
  var valaPay: any = valaPayer.toFixed(2);
  var com_intermediation = parameter.com_intermediation
    ? parameter.com_intermediation
    : 0;
  var com_conservation = parameter.com_conservation
    ? parameter.com_conservation
    : 0;
  var droit_garde = parameter.droit_garde ? parameter.droit_garde : 0;
  var com_courtage = parameter.com_courtage ? parameter.com_courtage : 0;
  var com1 =
    typeOpe === 'achat'
      ? detailOpe.prix * detailOpe.qte * com_intermediation
      : 0;
  var com2 =
    typeOpe === 'achat' ? detailOpe.prix * detailOpe.qte * com_conservation : 0;
  var com3 =
    typeOpe === 'achat' ? detailOpe.prix * detailOpe.qte * droit_garde : 0;
  var com4 =
    typeOpe === 'achat' ? detailOpe.prix * detailOpe.qte * com_courtage : 0;
  var mnt_global = 10000 * detailOpe.qte;
  var decote = 100 - detailOpe.prix / 100;
  const total =
    typeOpe === 'achat'
      ? Math.round(
          detailOpe.prix * detailOpe.qte +
            detailOpe.prix *
              detailOpe.qte *
              (0.0027 + 0.002 + 0.003 + 0.002) +
            parseFloat(valaPay),
        )
      : Math.round(detailOpe.prix * detailOpe.qte + parseFloat(valaPay));
  // var MontantAPayer = Math.round(
  //   typeOpe === 'achat'
  //     ? detailOpe.prix * detailOpe.qte +
  //         detailOpe.prix * detailOpe.qte * (0.0027 + 0.002 + 0.003 + 0.002) +
  //         parseFloat(valaPay)
  //     : detailOpe.prix * detailOpe.qte + parseFloat(valaPay),
  // );

  return (
    <Container>
      <div className='order-hero'>
        <div className='order-title'>
          <span>Confirmation de l'ordre</span>
          <strong>{titre.code}</strong>
        </div>
        <div className='side-badge'>
          {typeOpe === 'achat' ? 'Achat' : 'Vente'} · {formatNum(detailOpe.qte)}
        </div>
      </div>

      <div className='modal-grid'>
        <div className='section-card'>
          <span className='section-title'>Instrument</span>
          <div className='kv-row'>
            <span>Date valeur</span>
            <strong>{moment(datejour).format('DD/MM/YYYY')}</strong>
          </div>
          <div className='kv-row'>
            <span>Pays</span>
            <strong>{titre.pays}</strong>
          </div>
          <div className='kv-row'>
            <span>Instrument</span>
            <strong>{titre.instrument}</strong>
          </div>
          <div className='kv-row'>
            <span>Dernier coupon</span>
            <strong>{moment(titre.dateMaturite).format('DD/MM/YYYY')}</strong>
          </div>
          <div className='kv-row'>
            <span>Taux intérêt</span>
            <strong>{titre.tauxMarginal} %</strong>
          </div>
          <div className='kv-row'>
            <span>Fréquence paiement</span>
            <strong>{titre.frequencePaiement}</strong>
          </div>
        </div>

        <div className='section-card'>
          <span className='section-title'>Montant</span>
          <div className='kv-row'>
            <span>Quantité</span>
            <strong>{formatNum(parseInt(detailOpe.qte))}</strong>
          </div>
          <div className='kv-row'>
            <span>Montant global</span>
            <strong>{formatNum(parseInt(mnt_global.toFixed(2)))} XAF</strong>
          </div>
          <div className='kv-row'>
            <span>Décote</span>
            <strong>{formatNum(parseFloat(decote.toFixed(2)))}%</strong>
          </div>
          <div className='kv-row'>
            <span>Coupon couru à payer</span>
            <strong>{formatNum(parseInt(valaPay))} XAF</strong>
          </div>
          <div className='kv-row'>
            <span>Coupon à percevoir</span>
            <strong>{formatNum(parseInt(valaPercevoir))} XAF</strong>
          </div>
        </div>

        <div className='section-card'>
          <span className='section-title'>Commissions</span>
          <div className='kv-row'>
            <span>Intermédiation ({com_intermediation * 100}%)</span>
            <strong>{formatNum(parseInt(com1.toFixed(2)))} XAF</strong>
          </div>
          <div className='kv-row'>
            <span>Conservation ({com_conservation * 100}%)</span>
            <strong>{formatNum(parseInt(com2.toFixed(2)))} XAF</strong>
          </div>
          <div className='kv-row'>
            <span>Droit de garde ({droit_garde * 100}%)</span>
            <strong>{formatNum(parseInt(com3.toFixed(2)))} XAF</strong>
          </div>
          <div className='kv-row'>
            <span>Courtages ({com_courtage * 100}%)</span>
            <strong>{formatNum(parseInt(com4.toFixed(2)))} XAF</strong>
          </div>
        </div>

        <div className='section-card'>
          <span className='section-title'>Règlement</span>
          <div className='kv-row'>
            <span>Taux rendement</span>
            <strong>0%</strong>
          </div>
          <div className='kv-row'>
            <span>Formule</span>
            <strong>
              {typeOpe === 'achat' ? 'A*B + C+D+E+F+G' : 'A*B + C'}
            </strong>
          </div>
        </div>
      </div>

      {typeOpe === 'achat' && (
        <div className='section-card client-card'>
          <span className='section-title'>Client</span>
          <div className='client-line'>
            <span>Détenteur</span>
            <Select
              style={{ width: '100%' }}
              options={detenteurs}
              onChange={(val) => getSelectedDetenteur(val)}
            />
          </div>
        </div>
      )}

      <div className='total-strip'>
        <span>{typeOpe === 'achat' ? 'Total à payer' : 'Total à percevoir'}</span>
        <strong>{formatNum(total)} XAF</strong>
      </div>
    </Container>
  );
};
